import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Briefcase, MapPin, Clock, DollarSign } from 'lucide-react';
import '../styles/Pages.css';

const Careers = () => {
  const jobOpenings = [
    {
      title: 'Desarrollador Full Stack',
      department: 'Tecnología',
      location: 'Zulia, Venezuela',
      type: 'Tiempo Completo',
      description: 'Buscamos un desarrollador Full Stack con experiencia en React, Node.js y bases de datos SQL/NoSQL para unirse a nuestro equipo de desarrollo de productos.',
      requirements: [
        'Experiencia mínima de 3 años en desarrollo web',
        'Dominio de React, Node.js, y bases de datos',
        'Conocimiento de metodologías ágiles',
        'Capacidad para trabajar en equipo'
      ]
    },
    {
      title: 'Especialista en IoT',
      department: 'Tecnología',
      location: 'Zulia, Venezuela',
      type: 'Tiempo Completo',
      description: 'Buscamos un especialista en Internet de las Cosas (IoT) para liderar el desarrollo y mejora de nuestros dispositivos GPS y sistemas de comunicación.',
      requirements: [
        'Experiencia en desarrollo de soluciones IoT',
        'Conocimiento de protocolos de comunicación',
        'Experiencia con microcontroladores y sensores',
        'Grado en Ingeniería Electrónica o similar'
      ]
    },
    {
      title: 'Ejecutivo de Ventas',
      department: 'Comercial',
      location: 'Zulia, Venezuela / Remoto',
      type: 'Tiempo Completo',
      description: 'Buscamos ejecutivos de ventas con experiencia en soluciones tecnológicas B2B para expandir nuestra cartera de clientes en Latinoamérica.',
      requirements: [
        'Experiencia mínima de 2 años en ventas B2B',
        'Conocimiento del sector logístico o tecnológico',
        'Excelentes habilidades de comunicación',
        'Orientación a resultados'
      ]
    },
    {
      title: 'Especialista en Soporte Técnico',
      department: 'Atención al Cliente',
      location: 'Zulia, Venezuela',
      type: 'Tiempo Completo',
      description: 'Buscamos un especialista en soporte técnico para brindar asistencia a nuestros clientes en la implementación y uso de nuestras soluciones de rastreo.',
      requirements: [
        'Experiencia en soporte técnico',
        'Conocimientos de redes y GPS',
        'Excelente capacidad de resolución de problemas',
        'Orientación al cliente'
      ]
    }
  ];

  const benefits = [
    {
      icon: <Clock size={24} />,
      title: 'Horario Flexible',
      description: 'Valoramos el equilibrio entre vida personal y profesional con horarios flexibles.'
    },
    {
      icon: <DollarSign size={24} />,
      title: 'Salario Competitivo',
      description: 'Ofrecemos remuneración acorde al mercado y bonos por desempeño.'
    },
    {
      icon: <Briefcase size={24} />,
      title: 'Desarrollo Profesional',
      description: 'Oportunidades de crecimiento y capacitación continua.'
    },
    {
      icon: <MapPin size={24} />,
      title: 'Trabajo Remoto',
      description: 'Posibilidad de trabajo remoto o híbrido según el puesto.'
    }
  ];

  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Carreras en VillaTracking</h1>
            <p>Únete a nuestro equipo y ayúdanos a transformar la gestión de flotas vehiculares</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="careers-intro">
              <h2>Trabaja con Nosotros</h2>
              <p>En VillaTracking, estamos construyendo el futuro de la gestión de flotas y el rastreo vehicular. Buscamos personas talentosas y apasionadas que quieran formar parte de un equipo innovador y en constante crecimiento.</p>
              <p>Ofrecemos un ambiente de trabajo dinámico, oportunidades de desarrollo profesional y la posibilidad de contribuir a soluciones que impactan positivamente a cientos de empresas en Latinoamérica.</p>
            </div>
            
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div className="benefit-card" key={index}>
                  <div className="benefit-icon">
                    {benefit.icon}
                  </div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <h2>Oportunidades Actuales</h2>
            <div className="jobs-list">
              {jobOpenings.map((job, index) => (
                <div className="job-card" key={index}>
                  <div className="job-header">
                    <h3>{job.title}</h3>
                    <span className="job-department">{job.department}</span>
                  </div>
                  <div className="job-details">
                    <div className="job-detail">
                      <MapPin size={16} />
                      <span>{job.location}</span>
                    </div>
                    <div className="job-detail">
                      <Clock size={16} />
                      <span>{job.type}</span>
                    </div>
                  </div>
                  <p className="job-description">{job.description}</p>
                  <div className="job-requirements">
                    <h4>Requisitos:</h4>
                    <ul>
                      {job.requirements.map((req, reqIndex) => (
                        <li key={reqIndex}>{req}</li>
                      ))}
                    </ul>
                  </div>
                  <a href={`/careers/${job.title.toLowerCase().replace(/ /g, '-')}`} className="btn btn-secondary">Ver Detalles</a>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="careers-process">
              <h2>Proceso de Selección</h2>
              <div className="process-steps">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h3>Aplicación</h3>
                    <p>Envía tu CV y carta de presentación a través de nuestro formulario online.</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h3>Entrevista Inicial</h3>
                    <p>Si tu perfil coincide con lo que buscamos, te contactaremos para una primera entrevista telefónica.</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h3>Evaluación Técnica</h3>
                    <p>Dependiendo del puesto, realizarás una prueba técnica o caso práctico.</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h3>Entrevista Final</h3>
                    <p>Conocerás a tu futuro equipo y discutiremos detalles sobre el puesto y condiciones.</p>
                  </div>
                </div>
                <div className="process-step">
                  <div className="step-number">5</div>
                  <div className="step-content">
                    <h3>Oferta</h3>
                    <p>Si todo va bien, recibirás una oferta formal para unirte a nuestro equipo.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-cta">
          <div className="container">
            <h2>¿No encuentras el puesto que buscas?</h2>
            <p>Envíanos tu CV y cuéntanos por qué te gustaría formar parte de VillaTracking</p>
            <a href="mailto:soporte@villatracking.com" className="btn btn-primary btn-lg">Enviar CV</a>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Careers;